'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = createEntityReducer;

var _omit = require('lodash/omit');

var _omit2 = _interopRequireDefault(_omit);

var _isPlainObject = require('lodash/isPlainObject');

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _utils = require('../utils');

var _createReactions = require('./create-reactions');

var _createReactions2 = _interopRequireDefault(_createReactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createEntity(state, action) {
  var entity = action.payload.entity;

  return _extends({}, state, _defineProperty({}, entity.id, entity));
}

function updateEntity(state, action) {
  var _action$payload = action.payload,
      entity = _action$payload.entity,
      useDefault = _action$payload.useDefault;

  var data = (0, _omit2.default)(entity, 'id');
  return _extends({}, state, _defineProperty({}, entity.id, useDefault ? (0, _utils.defaultTo)(state[entity.id], data) : (0, _utils.update)(state[entity.id], data)));
}

function updateEntityId(state, action) {
  var _action$payload2 = action.payload,
      oldId = _action$payload2.oldId,
      newId = _action$payload2.newId;

  return _extends({}, (0, _omit2.default)(state, oldId), _defineProperty({}, newId, _extends({}, state[oldId], { id: newId })));
}

function deleteEntity(state, action) {
  var entity = action.payload.entity;

  return (0, _omit2.default)(state, entity.id);
}

function createEntityReducer(schema) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var reactions = (0, _createReactions2.default)(schema.getRelations());
  if (!(0, _isPlainObject2.default)(initialState)) {
    throw new Error('Invalid initial state for ' + schema.key + '. Initial state of an entity should be a plain object');
  }
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
      case '@@entman/CREATE_ENTITY_' + schema.key.toUpperCase():
        {
          return createEntity(state, action);
        }
      case '@@entman/UPDATE_ENTITY_' + schema.key.toUpperCase():
        {
          return updateEntity(state, action);
        }
      case '@@entman/DELETE_ENTITY_' + schema.key.toUpperCase():
        {
          return deleteEntity(state, action);
        }
      case '@@entman/UPDATE_ENTITY_ID_' + schema.key.toUpperCase():
        {
          return updateEntityId(state, action);
        }
      default:
        {
          var reaction = reactions[action.type];
          return typeof reaction === 'function' ? reaction(state, action) : state;
        }
    }
  };
}